<template>
  <div class="headerStyle">
    <div class="title" flat v-bind:style="setHeaderStyleByType()">
      <!-- LEAVE PERIOD HEADER -->
      <div class="head-card" v-if="leavePeriod">
        <div class="icons">
          <div
            class="id"
            :title="$t('headerInfoCard.leavePeriodId')"
            :style="{ color: 'grey' }"
          >
            # {{ leavePeriod.details.id }}
          </div>
        </div>
      </div>
      <!-- Title event -->
      <h4 v-if="!isEditing && leavePeriod">
        {{ $t("headerInfoCard.leavePeriodName") }}
      </h4>
      <div v-if="isEditing">
        <v-autocomplete
          light
          v-model="eventSelected.details.course.id"
          :items="courses"
          item-value="id"
          item-text="title"
          :rules="emptyField"
          persistent-hint
          single-line
          color="red darken-1"
        ></v-autocomplete>
      </div>

      <!-- TASK HEADER -->
      <div class="head-card" v-if="task">
        <div class="icons">
          <div
            class="id"
            :title="$t('headerInfoCard.taskId')"
            :style="{ color: 'grey' }"
          >
            # {{ task.details.id }}
          </div>
        </div>
        <div v-if="editMode" class="buttons">
          <v-btn
            icon
            small
            @click="confirmDeleteTask(task.details.id)"
            :disabled="!editMode"
          >
            <v-icon class="iconColor" :style="{ color: 'grey' }">
              mdi-delete
            </v-icon>
          </v-btn>

          <v-btn icon small :disabled="!editMode" @click="openEditTaskDialog()">
            <v-icon class="iconColor" :style="{ color: 'grey' }">
              mdi-pencil
            </v-icon>
          </v-btn>
        </div>
      </div>
      <h4 v-if="!isEditing && task">
        {{ $t("headerInfoCard.taskName") }} : {{ task.title }}
      </h4>

      <!-- INTERVENTION FOLLOWED HEADER -->
      <div class="head-card" v-if="interFollow">
        <div class="icons">
          <div class="id" :title="$t('editEventCard.interventionId')" :style="colorIdsAndIcons()">
            # {{ interFollow.details.id }}
          </div>

          <span>
            <v-icon :title="$t('enumIntStatus.interventionSuivie')">
              mdi-school
            </v-icon>
          </span>
        </div>
        <div v-if="editMode" class="buttons">
          <v-btn icon small @click="confirmDeleteIntervFollowed(interFollow.details.id)" :disabled="!editMode">
            <v-icon class="iconColor" :style="colorIdsAndIcons()">
              mdi-delete
            </v-icon>
          </v-btn>

          <!-- <v-btn icon small :disabled="!editMode" @click="openEditInterFollowDialog()">
            <v-icon class="iconColor" :style="colorIdsAndIcons()">
              mdi-pencil
            </v-icon>
          </v-btn> -->
        </div>
      </div>
      <h4 v-if="!isEditing && interFollow">
        {{ interFollow.course }}
      </h4>
    </div>

    <!-- Dialog delete for Task -->

    <v-card v-if="dialogDeleteTask" class="card-delete">
      <v-card-title class="headline">{{
      $t("crudEventInfocard.confirmDeleteTask")
      }}</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="F44336" text @click="closeDelete">{{
        $t("crudCourse.cancel")
        }}</v-btn>
        <v-btn
          id="button-delete-course"
          color="F44336"
          text
          @click="deleteTaskConfirm"
          >{{ $t("crudCourse.ok") }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <!-- Dialog delete for Intervention followed -->
    <v-card v-if="dialogDeleteIntervFollowed" class="card-delete">
      <v-card-title class="headline">{{
      $t("crudEventInfocard.confirmDeleteIntervFollowed")
      }}</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="F44336" text @click="closeDelete">{{
        $t("crudCourse.cancel")
        }}</v-btn>
        <v-btn id="button-delete-course" color="F44336" text @click="deleteIntervFollowedConfirm">{{ $t("crudCourse.ok")
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "header-info-card",
  props: {
    leavePeriod: {
      y: null,
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
      eventSiblings: [],
    },
    task: {
      y: null,
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
      eventSiblings: [],
    },
    interFollow: {
      y: null,
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
    },
    editMode: null,
    isEditing: null,
  },
  data() {
    return {
      selectedId: null,
      dialogDeleteTask: false,
      dialogDeleteIntervFollowed: false,
    };
  },
  methods: {
    setHeaderStyleByType() {
      if (this.leavePeriod || this.task) {
        return {
          background: "white",
          color: "grey",
          fontWeight: "bold",
          textAlign: "center",
        };
      }

      if (this.interFollow) {
        let interFollowAdvInterv = this.interFollow.details.advInterventionDto;

        return interFollowAdvInterv.eventSiblings.length > 0
          ? { backgroundColor: "gainsboro", color: "white" }
          : interFollowAdvInterv.validated
            ? interFollowAdvInterv.type === "INTRA"
              ? {
                backgroundColor: "#ffd320",
                color: this.interFollow.color,
                fontWeight: "bold",
              }
              : {
                background: this.interFollow.color,
                color: "#ffffff",
                fontWeight: "bold",
              }
            : {
              background: "#FFFFCC",
              color: this.interFollow.color,
              fontWeight: "bold",
            };
      }
    },
    colorIdsAndIcons() {
      let interFollowAdvInterv = this.interFollow.details.advInterventionDto;

      return interFollowAdvInterv.eventSiblings.length > 0
        ? { color: "white" }
        : interFollowAdvInterv.validated
          ? interFollowAdvInterv.type === "INTRA"
            ? {
              color: this.interFollow.color,
            }
            : {
              color: "#ffffff",
            }
          : {
            color: this.interFollow.color,
          };
    },
    confirmDeleteTask(id) {
      this.selectedId = id;
      this.dialogDeleteTask = true;
    },
    closeDelete() {
      this.dialogDeleteTask = false;
      this.dialogDeleteIntervFollowed = false;
    },
    deleteTaskConfirm() {
      this.deleteTask(this.selectedId);
      this.dialogDeleteTask = false;
      this.$emit("close");
    },
    confirmDeleteIntervFollowed(id){
      this.selectedId = id;
      this.dialogDeleteIntervFollowed = true;
    },
    deleteIntervFollowedConfirm(){
      this.deleteInterventionFollowed(this.selectedId);
      this.dialogDeleteIntervFollowed = false;
      this.$emit("close");
    },
    openEditTaskDialog() {
      this.$emit("taskEdit");
    },
    // openEditInterFollowDialog(){
    //   this.$emit("interFollowEdit");
    // },

    ...mapActions("taskModule", ["deleteTask"]),
    ...mapActions("interventionFollowedModule", [
      "deleteInterventionFollowed",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.title {
  border-radius: 20px 20px 0px 0px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  color: var(--card-color);
  text-align: center;
}
</style>
